/**
 * Sync crossed-out “was” price when variant changes (values from Liquid JSON map).
 */
(function () {
  const roots = document.querySelectorAll('[data-product-price-promo]');
  if (!roots.length) return;

  function getActiveVariantId(root) {
    const productInfo = root.closest('product-info');
    const sel = productInfo?.querySelector('variant-selects [data-selected-variant]');
    if (sel && sel.innerHTML) {
      try {
        return String(JSON.parse(sel.innerHTML).id);
      } catch (e) {
        /* fall through */
      }
    }
    const sectionId = root.dataset.sectionId;
    const form =
      productInfo?.querySelector(`#product-form-${sectionId}`) ||
      document.getElementById(`product-form-${sectionId}`);
    return form?.querySelector('input[name="id"]')?.value || null;
  }

  function getMapLabel(map, vid) {
    if (map == null || vid == null || vid === '') return undefined;
    const key = String(vid);
    if (Object.prototype.hasOwnProperty.call(map, key)) return map[key];
    return undefined;
  }

  function updateRoot(root) {
    const wasEl = root.querySelector('.js-price-promo-was');
    const mapEl = document.getElementById(`ProductPricePromoWas-${root.dataset.sectionId}`);
    if (!wasEl || !mapEl) return;

    const vid = getActiveVariantId(root);
    if (!vid) return;

    let map;
    try {
      map = JSON.parse(mapEl.textContent.trim());
    } catch (e) {
      return;
    }

    const label = getMapLabel(map, vid);
    if (label) {
      wasEl.textContent = label;
      wasEl.hidden = false;
      wasEl.removeAttribute('hidden');
    } else if (label === '') {
      wasEl.textContent = '';
      wasEl.hidden = true;
    }
  }

  function refreshAll() {
    roots.forEach((root) => updateRoot(root));
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      requestAnimationFrame(() => requestAnimationFrame(refreshAll));
    });
  }

  roots.forEach((root) => {
    const productInfo = root.closest('product-info');
    const sectionId = root.dataset.sectionId;
    productInfo?.querySelector(`#product-form-${sectionId} input[name="id"]`)?.addEventListener('change', () => {
      requestAnimationFrame(refreshAll);
    });
  });
})();
